import { http } from '.';

export interface StrokeData {
  id?: string;
  canvasSize?: {
    width: number;
    height: number;
  };
  simplifiedStrokes: Array<{
    points: Array<{
      x: number;
      y: number;
      w?: number;
      t?: number;
    }>;
    color?: {
      r: number;
      g: number;
      b: number;
      a: number;
    };
  }>;
}

export interface StrokeDataSession {
  id: number;
  user: string;
  username: string;
  stroke_data_file: string;
  stroke_data?: StrokeData | null; // Only present when fetching individual sessions
  created_at: string;
  updated_at: string;
}

export const fetchStrokeDataSessions = async (): Promise<StrokeDataSession[]> => {
  const response = await http.get<StrokeDataSession[]>('/stroke-sessions/');
  return response;
};

export const fetchStrokeDataSession = async (sessionId: number): Promise<StrokeDataSession> => {
  const response = await http.get<StrokeDataSession>(`/stroke-sessions/${sessionId}/`);
  return response;
};

